<template>
  <ul class="panel">
    <li
      v-for="service in services"
      class="panel-block is-flex is-justify-content-space-between"
    >
      <div class="is-flex">
        <router-link :to="`/categories/${service.serviceId}/root`">
          <span class="has-text-weight-semibold">{{ service.label }}</span>
          <span class="ml-1">({{ service.serviceId }})</span>
        </router-link>

        <!-- <router-link
          v-if="isAdmin === false"
          :to="`${urlPrefix}/posts/${service.serviceId}/start`"
          class="button ml-4"
        >
          <span class="icon">
            <i class="far fa-play-circle"></i>
          </span>
          <span>{{ $t('common.start') }}</span>
        </router-link> -->
      </div>

      <!-- <router-link
        v-if="isAdmin === false"
        :to="`/user/drills/progress/${service.serviceId}`"
        class=""
      >
        <span class="icon">
          <i class="fas fa-tasks"></i>
        </span>
        <span>{{ $t('term.progress') }}</span>
      </router-link> -->
    </li>
  </ul>
</template>
<script>
export default {
  name: 'ServiceLinks',

  props: {
    services: {
      type: Array,
      default: [],
    },

    isAdmin: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    urlPrefix() {
      return this.isAdmin ? '/admin' : ''
    },
  },
}
</script>
